import { render, staticRenderFns } from "./ChangeRouteLocality.vue?vue&type=template&id=6c0a2871&scoped=true"
import script from "./ChangeRouteLocality.vue?vue&type=script&lang=js"
export * from "./ChangeRouteLocality.vue?vue&type=script&lang=js"
import style0 from "./ChangeRouteLocality.vue?vue&type=style&index=0&id=6c0a2871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a2871",
  null
  
)

export default component.exports